export default __webpack_public_path__ + "static/media/RW.c7ce9e68.svg";